{
  "info": "Informacije",
  "negative": "Pogreška",
  "positive": "Uspješno"
}
